// CardDetails.js
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import axios from 'axios';
import { jwtDecode } from "jwt-decode";

const stripePromise = loadStripe("pk_test_51Qhe4xFYsQpDHoxcoyKC3uAYxD0UYXjrniJTfEtPubNKnLv5PGwSvdYZRmllMeRRnDWyj2REL6DoI5P6WbVNeWU500IJ5547pt");

const CardDetails = () => {
    return (
        <div style={containerStyle}>
            <Elements stripe={stripePromise}>
                <CheckoutForm/>
            </Elements>
        </div>
    );
};

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL;


  const [processingPayment, setProcessingPayment] = useState(false);
  const [stripeReady, setStripeReady] = useState(false);
  const [userId, setUserId] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const paymentType = searchParams.get('paymentType');

  const totalAmount = searchParams.get('totalAmount');
  const orderPrice = searchParams.get('orderPrice');
  const stripeFee = searchParams.get('stripeFee');

  const [paymentDate, setPaymentDate] = useState(new Date().toISOString());
  const ibanFromUrl = searchParams.get('iban'); // Get IBAN from URL params
  const [iban, setIban] = useState(ibanFromUrl || ""); // Use local state for IBAN input

  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [trustPolicyBroken, setTrustPolicyBroken] = useState(false);
  const [ibanVerified, setIbanVerified] = useState(false);
  const [depositSelected, setDepositSelected] = useState(false);
  const [showIbanForm, setShowIbanForm] = useState(false);
  const [savingIban, setSavingIban] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setUserId(decodedToken.userId);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (stripe && elements) {
      setStripeReady(true);
    }
  }, [stripe, elements]);
  const handleSaveDeposit = async () => {
    try {
      setProcessingPayment(true);

      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement(CardElement),
      });

      if (error) {
        console.error("Stripe error:", error);
        alert(error.message);
        return;
      }

      let endpoint = `${API_URL}/api/payment/save-deposit`;
      let requestBody = {
        userId: userId,
        amount: 10, // Deposit amount
        currency: "eur",
        paymentMethodId: paymentMethod.id, // Send paymentMethodId
      };

      const response = await axios.post(endpoint, requestBody, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.data.success) {
        alert("Paiement de la caution réussi !");
        navigate('/payment', { state: { isDepositSelected: true } });
      } else {
        alert("Le paiement de la caution a échoué. Veuillez réessayer.");
      }

    } catch (err) {
      console.error("Payment error:", err);
      alert("Le paiement a échoué. Veuillez réessayer.");
    } finally {
      setProcessingPayment(false);
    }
  };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            alert("Stripe.js est toujours en cours de chargement...");
            return;
        }

        let endpoint = "";
        let requestBody = {
            userId: userId,
        };
      try {
            setProcessingPayment(true);

            const {error, paymentMethod} = await stripe.createPaymentMethod({
                type: 'card',
                card: elements.getElement(CardElement),
            });

            if (error) {
                console.error("Stripe error:", error);
                alert(error.message);
                return;
            }

            let buttonText = "Submit";

            if (paymentType === 'subscription') {
                endpoint = `${API_URL}/api/payment/create-subscription`;
                requestBody.priceId = "price_1QowUWFYsQpDHoxcmeAFNbRA";
                buttonText = "S'abonner maintenant (2,99 €)";
                requestBody.paymentType = 'subscription'; // explicitly set payment type
                requestBody.paymentMethodId =  paymentMethod.id;

            }  else if (paymentType === 'card') {
                endpoint = `${API_URL}/api/payment/create-restaurantpayment`;
                requestBody.amount = parseFloat(totalAmount);
                requestBody.currency = "eur";
                requestBody.date = paymentDate;
                requestBody.paymentMethodId =  paymentMethod.id;
                buttonText = "Payer maintenant";
            }
             // Send payment data to backend
            const response = await axios.post(endpoint, requestBody, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("userToken")}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.success) {
                alert("Paiement réussi !");
                setPaymentSuccess(true);

                if (paymentType === 'subscription') {
                    navigate('/payment', {state: {isSubscribed: true}});
                } else  if (paymentType === 'card') {
                   navigate('/success'); //It need to send another path if u change the conditon of subsciption, im using just to know is working
                }

            } else {
                alert("Le paiement a échoué. Veuillez réessayer.");
            }

        } catch (err) {
            console.error("Payment error:", err);
            alert("Le paiement a échoué. Veuillez réessayer.");
        } finally {
            setProcessingPayment(false);
        }
    };
   const handleSaveIban = async () => {
        if (iban.trim() === "") {
            alert("Veuillez entrer un IBAN valide.");
            return;
        }
          try {
            setSavingIban(true);

            let endpoint = `${API_URL}/api/payment/save-iban`;
            let requestBody = {
                userId: userId,
                iban: iban
            };

            // Send payment data to backend
            const response = await axios.post(endpoint, requestBody, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("userToken")}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.success) {
                alert("IBAN enregistré avec succès !");
                navigate('/payment', { state: { ibanVerified: true } });
            } else {
                alert("Échec de l'enregistrement de l'IBAN. Veuillez réessayer.");
            }

        } catch (err) {
            console.error("Payment error:", err);
            alert("Le paiement a échoué. Veuillez réessayer.");
        } finally {
            setSavingIban(false);
        }

    };


    const createOrder = async () => {
        try {
            const storedCart = localStorage.getItem("cart");
            const cartItems = storedCart ? JSON.parse(storedCart) : [];

            if (cartItems.length === 0) {
                alert("Le panier est vide. Impossible de créer la commande.");
                return;
            }

            const totalPrice = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);

            const response = await axios.post(
                `${API_URL}/api/create-order`,
                {cartItems, totalPrice},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("userToken")}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.status === 201) {
                const orderToken = response.data.orderId;
                localStorage.removeItem("cart");
                navigate(`/tokenDetails/${orderToken}`);
            } else {
                alert(`Erreur lors de la création de la commande : ${response.status}`);
            }

        } catch (error) {
            console.error("Error creating order:", error);
            alert("Erreur lors de la création de la commande. Veuillez réessayer.");
        }
    };

    let buttonText = "Submit"; // Default button text

   let formContent = null;
        if (paymentType === 'save-deposit') {
            formContent = (
                <div style={formSectionStyle}>
                    <h5 style={headingStyle}>Payer une caution remboursable de 10 € :</h5>
                    <form onSubmit={handleSubmit}>
                        <CardElement
                            options={{
                                style: {
                                    base: {
                                        fontSize: '16px',
                                        color: '#424770',
                                        '::placeholder': {color: '#aab7c4'},
                                    },
                                    invalid: {color: '#9e2146'},
                                },
                            }}
                        />
                        <button style={buttonStyle} type="button" disabled={!stripeReady || processingPayment} onClick={handleSaveDeposit}>
                            {processingPayment ? "Traitement..." : "Payer une caution de 10 €"}
                        </button>
                    </form>
                </div>
            );
        }
              else if (paymentType === 'card') {
            formContent = (
                <div style={formSectionStyle}>
                     <h5 style={headingStyle}>Saisissez les détails de votre carte :</h5>
                    <form onSubmit={handleSubmit}>
                        <CardElement
                            options={{
                                style: {
                                    base: {
                                        fontSize: '16px',
                                        color: '#424770',
                                        '::placeholder': {color: '#aab7c4'},
                                    },
                                    invalid: {color: '#9e2146'},
                                },
                            }}
                        />
                        <button style={buttonStyle} type="submit" disabled={!stripeReady || processingPayment}>
                            {processingPayment ? "Traitement..." : "Payer"}
                        </button>
                    </form>
                </div>
            );
        }
           else if (paymentType === 'subscription') {
            formContent = (
              <div style={formSectionStyle}>
                <h5 style={headingStyle}>Saisissez les détails de votre carte :</h5>
                    <form onSubmit={handleSubmit}>
                        <CardElement
                            options={{
                                style: {
                                    base: {
                                        fontSize: '16px',
                                        color: '#424770',
                                        '::placeholder': {color: '#aab7c4'},
                                    },
                                    invalid: {color: '#9e2146'},
                                },
                            }}
                        />
                        <button style={buttonStyle} type="submit" disabled={!stripeReady || processingPayment}>
                            {processingPayment ? "Traitement..." : "S'abonner"}
                        </button>
                    </form>
                 </div>
              );
           }
         else if (paymentType === 'save-iban') {
            formContent = (
                <div style={formSectionStyle}>
                    <h5 style={headingStyle}>Entrez votre IBAN :</h5>
                    <form onSubmit={handleSubmit}>
                        <div style={ibanVerificationStyle}>
                            <input
                                type="text"
                                style={formControlStyle}
                                placeholder="Entrez votre IBAN"
                                value={iban}
                                onChange={(e) => setIban(e.target.value)}
                                disabled={savingIban}
                            />
                            <button
                                style={saveIbanButtonStyle}
                                type="button" // Changed to type="button"
                                onClick={handleSaveIban} // Call the new function
                                disabled={processingPayment || savingIban}
                            >
                                {savingIban ? "Enregistrement..." : "Enregistrer IBAN"}
                            </button>
                        </div>
                    </form>
                </div>
            );
        }

        else {
            formContent = (
                <div style={formSectionStyle}>
                 <h5 style={headingStyle}>Saisissez les détails de votre carte :</h5>
                <form onSubmit={handleSubmit}>
                    <CardElement
                        options={{
                            style: {
                                base: {
                                    fontSize: '16px',
                                    color: '#424770',
                                    '::placeholder': {color: '#aab7c4'},
                                },
                                invalid: {color: '#9e2146'},
                            },
                        }}
                    />
                    <button style={buttonStyle} type="submit" disabled={!stripeReady || processingPayment}>
                        {processingPayment ? "Traitement..." : buttonText}
                    </button>
                </form>
                </div>
            );
        }

    return (
        <div style={mainContainerStyle}>
             {/* Header */}
        <header style={headerStyle}>
            <div style={headerContentStyle}>
                <div style={logoStyle}>Lememeprix</div>
                
                <div style={headerActionsStyle}>
                    <button style={cartButtonStyle}>
                        <i className="fa-solid fa-cart-shopping" style={cartIconStyle}></i>
                        <span style={cartCountStyle}>3</span>
                    </button>
                    <button>
                        <img src="https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg" alt="Profile" style={profileImageStyle} />
                    </button>
                </div>
            </div>
        </header>

        {/* Main Content */}
        <main style={mainStyle}>
            {/* Hero Section */}
            <section style={heroSectionStyle}>
                <div style={heroOverlayStyle}>
                    <img className="w-full h-full object-cover blur-sm" src="https://storage.googleapis.com/uxpilot-auth.appspot.com/a25e59ae59-e1ad897e4a5f5ce4e70d.png" alt="premium restaurant interior with elegant dining setup, moody lighting" style={heroImageStyle} />
                </div>
                <div style={heroContentContainerStyle}>
                    <div style={heroContentStyle}>
                        <h1 style={heroTitleStyle}>Paiement sécurisé pour La Maison Rouge</h1>
                    </div>
                </div>
            </section>

            {/* Payment Section */}
            <section style={paymentSectionStyle}>
                <div style={paymentContainerStyle}>
                    {/* Credit Card Input */}
                    <div style={cardEntryStyle}>
                        <div style={cardHeaderStyle}>
                            <h2 style={paymentDetailsHeadingStyle}>Détails de paiement</h2>
                            <div style={cardIconsStyle}>
                                <i className="fa-brands fa-cc-visa" style={cardIconStyle}></i>
                                <i className="fa-brands fa-cc-mastercard" style={cardIconStyle}></i>
                                <i className="fa-brands fa-cc-amex" style={cardIconStyle}></i>
                            </div>
                        </div>

                        {/* Card Element */}
                        {formContent}

                    {/* Billing Summary */}
                    <div style={billingSummaryStyle}>
                        <h2 style={orderSummaryHeadingStyle}>Résumé de la commande</h2>
                        <div style={orderSummaryContentStyle}>
                            <div style={summaryItemStyle}>
                                <span>Sous-total</span>
                                <span>45,90 €</span>
                            </div>
                            <div style={summaryItemStyle}>
                                <span>Frais de service</span>
                                <span>0,20 €</span>
                            </div>
                            <div style={summaryTotalStyle}>
                                <span>Total</span>
                                <span>46,10 €</span>
                            </div>
                        </div>
                    </div>

                    {/* Save Card Option */}
                    <div style={saveCardStyle}>
                        <label style={saveCardLabelStyle}>
                            <input type="checkbox" style={saveCardCheckboxStyle} />
                            <span>Enregistrer cette carte pour de futures commandes</span>
                        </label>
                    </div>

                    {/* CTA Button */}
                    <button style={paymentButtonStyle}>
                        Payer en toute sécurité maintenant
                    </button>
                     </div>
                </div>
            </section>
        </main>

        {/* Footer */}
        <footer style={footerStyle}>
            <div style={footerContainerStyle}>
                <div style={footerGridStyle}>
                    <div>
                        <h3 style={footerHeadingStyle}>Lememeprix</h3>
                        <p style={footerTextStyle}>Votre service de livraison de nourriture haut de gamme</p>
                    </div>
                    <div>
                        <h4 style={footerSubheadingStyle}>Liens rapides</h4>
                        <ul style={footerListStyle}>
                            <li><span style={footerLinkStyle}>À propos de nous</span></li>
                            <li><span style={footerLinkStyle}>Contact</span></li>
                            <li><span style={footerLinkStyle}>Politique de confidentialité</span></li>
                        </ul>
                    </div>
                    <div>
                        <h4 style={footerSubheadingStyle}>Assistance</h4>
                        <ul style={footerListStyle}>
                            <li><span style={footerLinkStyle}>Centre d'aide</span></li>
                            <li><span style={footerLinkStyle}>Conditions d'utilisation</span></li>
                            <li><span style={footerLinkStyle}>Juridique</span></li>
                        </ul>
                    </div>
                    <div>
                        <h4 style={footerSubheadingStyle}>Suivez-nous</h4>
                        <div style={footerSocialStyle}>
                            <span style={socialIconStyle}><i className="fa-brands fa-instagram"></i></span>
                            <span style={socialIconStyle}><i className="fa-brands fa-facebook"></i></span>
                            <span style={socialIconStyle}><i className="fa-brands fa-twitter"></i></span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        </div>
    );
};
// Styles for the entire component
const containerStyle = {
    minHeight: '100vh',
    backgroundColor: '#fff',
    fontFamily: 'Arial, sans-serif',
};

// Styles for the header
const headerStyle = {
    position: 'fixed',
    width: '100%',
    backgroundColor: '#fff',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    zIndex: '50',
};

const headerContentStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    maxWidth: '1200px', // Add a max width for larger screens
    margin: '0 auto',     // Center the header content
};

const logoStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
};

const searchBoxContainerStyle = {
    flexGrow: '1',
    margin: '0 16px',
};

const searchBoxRelativeStyle = {
    position: 'relative',
};

const locationIconStyle = {
    position: 'absolute',
    left: '12px',
    top: '12px',
    color: '#777',
};

const searchBoxInputStyle = {
    width: '100%',
    paddingLeft: '40px',
    paddingRight: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    outline: 'none',
};

const headerActionsStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
};

const cartButtonStyle = {
    position: 'relative',
    backgroundColor: 'transparent', // Make the button background transparent
    border: 'none',               // Remove the border
    padding: 0,                   // Remove default padding
    cursor: 'pointer',            // Add a pointer cursor
};

const cartIconStyle = {
    fontSize: '24px',
};

const cartCountStyle = {
    position: 'absolute',
    top: '-8px',
    right: '-8px',
    backgroundColor: 'red',
    color: 'white',
    fontSize: '12px',
    borderRadius: '50%',
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

const profileImageStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
};

// Styles for the main section
const mainStyle = {
    paddingTop: '80px',
};

const heroSectionStyle = {
    position: 'relative',
    height: '600px',
};

const heroOverlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
};

const heroImageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    filter: 'blur(5px)',
};

const heroContentContainerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 16px',
};

const heroContentStyle = {
    maxWidth: '800px',
    color: 'white',
    textAlign: 'center',
};

const heroTitleStyle = {
    fontSize: '48px',
    fontWeight: 'bold',
    marginBottom: '24px',
};
const paymentSectionStyle = {
    padding: '48px 0',
};

const paymentContainerStyle = {
    maxWidth: '960px',
    margin: '0 auto',
    padding: '0 16px',
};

const cardEntryStyle = {
    backgroundColor: 'white',
    borderRadius: '16px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    padding: '32px',
    marginBottom: '32px',
};

const cardHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
};

const paymentDetailsHeadingStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
};

const cardIconsStyle = {
    display: 'flex',
    gap: '12px',
};

const cardIconStyle = {
    fontSize: '32px',
    color: '#777',
};

const billingSummaryStyle = {
    backgroundColor: '#f7f7f7',
    borderRadius: '16px',
    padding: '32px',
    marginBottom: '32px',
};

const orderSummaryHeadingStyle = {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '24px',
};

const orderSummaryContentStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
};

const summaryItemStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '16px',
};

const summaryTotalStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '20px',
    fontWeight: 'bold',
    paddingTop: '16px',
    borderTop: '1px solid #ccc',
};

const saveCardStyle = {
    marginBottom: '32px',
};

const saveCardLabelStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
};

const saveCardCheckboxStyle = {
    width: '20px',
    height: '20px',
    borderRadius: '4px',
    border: '1px solid #ccc',
};

const paymentButtonStyle = {
    width: '100%',
    backgroundColor: '#e53e3e',
    color: 'white',
    padding: '16px',
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
};
// Styles for the footer
const footerStyle = {
    backgroundColor: '#000',
    color: '#fff',
    marginTop: '160px',
};

const footerContainerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '48px 16px',
};

const footerGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '32px',
};

const footerHeadingStyle = {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '16px',
};

const footerSubheadingStyle = {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '16px',
};

const footerTextStyle = {
    color: '#aaa',
};

const footerListStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    color: '#aaa',
};

const footerLinkStyle = {
    cursor: 'pointer',
};

const footerSocialStyle = {
    display: 'flex',
    gap: '16px',
};

const socialIconStyle = {
    cursor: 'pointer',
};

// Specific form styles

const formSectionStyle = {
    marginBottom: '20px',
    padding: '20px',
    border: '1px solid #ddd',
    borderRadius: '5px',
};

const headingStyle = {
    fontSize: '1.2em',
    marginBottom: '10px',
};

const buttonStyle = {
    backgroundColor: '#4CAF50',
    color: 'white',
    padding: '10px 15px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
};

const ibanVerificationStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
};

const formControlStyle = {
    padding: '8px',
    borderRadius: '5px',
    border: '1px solid #ccc',
    width: '100%', // Make input full width
    boxSizing: 'border-box' // Include padding and border in the element's total width and height
};

const saveIbanButtonStyle = {
    backgroundColor: '#008CBA',
    color: 'white',
    padding: '10px 15px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
};

const mainContainerStyle = {
    minHeight: '100vh',
    backgroundColor: '#fff',
    fontFamily: 'Arial, sans-serif',
    display: 'flex',
    flexDirection: 'column',
};

export default CardDetails;